module.exports = __webpack_public_path__ + "static/media/ONE.ae2fc049.svg";